import useGetApi from 'src/api/useGetApi';
import { FamousOrderFromSql } from './FamousOrderTypes';

export enum OrderFetchStatus {
  pending = 'pending',
  fetching = 'fetching',
  success = 'success',
  failed = 'failed',
}

export enum EdiInvoiceType {
  Invoice810 = '810',
  Invoice880 = '880',
}

export interface FamousSalesOrderDTO {
  id: string;
  famousSalesOrderId: string;
  orderDetails: FamousOrderFromSql[] | null;
  orderFetchStatus: OrderFetchStatus;
  orderFetchError: Record<string, unknown> | null;
  edi810SentAt: Date | null;
  edi810Status: string | null;
  edi810StatusLastFetchedAt: Date | null;
  ediInvoiceSentAt: Date | null;
  ediInvoiceStatus: string | null;
  ediInvoiceStatusLastFetchedAt: Date | null;
  ediInvoiceType: EdiInvoiceType | null;
  createdAt: Date;
  updatedAt: Date;
}

interface PageInfo {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

interface QueryParams {
  page?: number;
  pageSize?: number;
  orderFetchStatus?: OrderFetchStatus;
  famousSalesOrderId?: string;
}

type ApiResponse = {
  edges: FamousSalesOrderDTO[];
  pageInfo: PageInfo;
};

const useFamousSalesOrders = (params?: QueryParams, enabled?: boolean) => {
  return useGetApi<ApiResponse>({
    endpoint: 'famous/sales-orders',
    queryParameters: params,
    options: {
      enabled,
    },
  });
};

export default useFamousSalesOrders;
